// TODO make some graphs
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { DataTable, Page, AppProvider, Card, Layout } from '@shopify/polaris';

import SellerStats from './components/SellerStats';

import GeneralStatsCard from './components/GeneralStatsCard';

const propTypes = {
  product: PropTypes.object.isRequired,
  seller: PropTypes.object.isRequired,
  order_supply: PropTypes.object.isRequired,
}

const AdminDashboard = (props) => (
  <AppProvider
    i18n={{
      Polaris: {
        DataTable: {
          totalsRowHeading: "Total"
        }
      }
    }}
  >
    <Page
      fullWidth
    >
      { console.log(props) }
      <Layout>
        <Layout.Section secondary>
          <GeneralStatsCard title={ I18n.t("dashboard.product_stats") } total={ props.product.total } rows={ props.product.rows } />
          <GeneralStatsCard title={ I18n.t("dashboard.transfer.stats") } total={ props.transfer.total } rows={ props.transfer.rows } /> 
          <GeneralStatsCard title={ I18n.t("dashboard.order_supply.stats") } total={ props.order_supply.total } rows={[]} /> 
        </Layout.Section>

        <Layout.Section>
          <SellerStats seller={ props.seller } />
        </Layout.Section>
      </Layout>

    </Page>
  </AppProvider>
);


AdminDashboard.propTypes = propTypes;

export default AdminDashboard;
